import React, {useEffect, Suspense, lazy, useState} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {withFirebase} from 'react-redux-firebase';
import {compose} from 'redux';

import Header from './header/canary';
import Footer from './footer/footer';
import LiveChat from 'react-livechat'
import {Loading} from '../utility/loading';
import {parseSearch } from '../utility/parse-search';
import CookiesModal from '../../vicbooth/shared/ui/cookies-modal';
import ReactPixel from 'react-facebook-pixel';
import NewsModal from './commons/news-modal';
import Cookies from 'js-cookie';
import { Helmet } from 'react-helmet';

const Articles = lazy(() => import('./articles/articles-container'/* webpackChunkName: "articles" */ ))
const Article = lazy(() => import('./articles/article-container'/* webpackChunkName: "article" */ ))
const News = lazy(() => import('./news/news'/* webpackChunkName: "news" */ ))
const NewsArticleContainer = lazy(() => import('./news/news-article'/* webpackChunkName: "news-article" */ ))
const PagesContainer = lazy(() => import('./pages/page'/* webpackChunkName: "page" */ ))
const ProductContainer = lazy(() => import('./product/product-container'/* webpackChunkName: "product" */ ))
const BundleContainer = lazy(() => import('./bundle/bundle-container'/* webpackChunkName: "bundle" */ ))
const BundlesContainer = lazy(() => import('./bundles/bundles-container'/* webpackChunkName: "bundles" */ ))
const PortfolioContainer = lazy(() => import('./portfolio/portfolio-container'/* webpackChunkName: "portfolio" */ ))
const ProjectContainer = lazy(() => import('./portfolio/project-container'/* webpackChunkName: "project" */ ))
const Signup = lazy(() => import('./signup/signup'/* webpackChunkName: "signup" */ ))
const Login = lazy(() => import('./login/login'/* webpackChunkName: "login" */ ))
const ReservedArea = lazy(() => import('./reserved-area/reserved-area'/* webpackChunkName: "reserved-area" */ ))
const OrderDetails = lazy(() => import('./reserved-area/order-detail'/* webpackChunkName: "order-details" */ ))
const NotFound = lazy(() => import('./404/not-found'/* webpackChunkName: "not-found" */ ))
const ErrorBoundary = lazy(() => import('./500/error-boundary'/* webpackChunkName: "error-boundary" */ ))
const Checkout = lazy(() => import('./checkout/checkout'/* webpackChunkName: "checkout" */ ))
const BulkBuy = lazy(() => import('./bulk-buy/bulk-buy-container'/* webpackChunkName: "order-builder" */ ))
const ProductStock = lazy(() => import('./product-stock/product-stock-container'/* webpackChunkName: "product-stock" */ ))
const SearchContainer = lazy(() => import('./search/search-container'/* webpackChunkName: "search" */ ))
const AllProductsContainer = lazy(() => import('./all-products/all-products-container'/* webpackChunkName: "all-products" */ ))
const PublicSpaces = lazy(() => import('./areas/public-spaces'/* webpackChunkName: "public-spaces" */ ))
const HifiHomeCinema = lazy(() => import('./areas/hifi-&-home-cinema'/* webpackChunkName: "home-cinema" */ ))
const ProfessionalAudio = lazy(() => import('./areas/professional-audio'/* webpackChunkName: "professional-audio" */ ))
const Workspaces = lazy(() => import('./areas/workspaces'/* webpackChunkName: "workspaces" */ ))
const WhitepapersContainer = lazy(() => import('./whitepapers/whitepapers-container'/* webpackChunkName: "whitepapers" */ ))
const CatalogsContainer = lazy(() => import('./catalogs/catalogs-container'/* webpackChunkName: "catalogs" */ ))
//const ProjectRequest = lazy(() => import('./project-request/project-request'/* webpackChunkName: "project-request" */ ))
const Sustainability = lazy(() => import('./sustainability/sustainability'/* webpackChunkName: "sustainability" */ ))
const PrivacyPolicy = lazy(() => import('./terms/privacy-policy'/* webpackChunkName: "terms-conditions" */ ))
const CookiesPolicy = lazy(() => import('./cookies/cookies-policy'/* webpackChunkName: "cookies-conditions" */ ))
const About = lazy(() => import('./about/about'/* webpackChunkName: "about" */ ))
const Services = lazy(() => import('./services/services'/* webpackChunkName: "services" */ ))
const QuickLinks = lazy(() => import('./quick-links/quick-links'/* webpackChunkName: "quick-links" */ ))
const BusinessAreas = lazy(() => import('./business-areas/business-areas'/* webpackChunkName: "business-areas" */ ))
const Videos = lazy(() => import('./videos/videos'/* webpackChunkName: "videos" */ ))
const AcousticPrinciples = lazy(() => import('./acoustic-principles/acoustic-principles'/* webpackChunkName: "acoustic-principles" */ ))
const WhereToBuy = lazy(() => import('./where-to-buy/where-to-buy'/* webpackChunkName: "where-to-buy" */ ))
const CanaryHome = lazy(() => import('./canary/hp'/* webpackChunkName: "canary-hp" */ ))
const CanaryProjectRequest = lazy(() => import('./canary/project-request'/* webpackChunkName: "canary-project-request" */ ))
const RTToolCalculator = lazy(() => import('./rt-tool/index'/* webpackChunkName: "rt-tool" */ ))

const AuthCookieSetter = compose(
  withFirebase,
  connect((state) => ({
    auth: state.firebase.auth
  }))
)(props => {
  useEffect(() => {
    props.firebase.auth().currentUser
      ? props.firebase
          .auth()
            .currentUser.getIdToken(true)
            .then((token) => {
              Cookies.set('__session', token, { expires: 3600 })
            })
        : null;
  }, [props.auth.uid]);
  return null;
});

const Client = props => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    ReactPixel.init('388308378554492');
    setTimeout(() => setShowModal(true), 2000)
  }, [])

  return (
    <React.Fragment>
      <AuthCookieSetter />
      <Header />
      <Helmet defaultTitle='Vicoustic – Innovative Acoustic Solutions'></Helmet>

      {showModal && <NewsModal onClose={() => setShowModal(false)} />}
      <ErrorBoundary>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path={'/'} component={CanaryHome} />
            <Route exact path={'/professional-audio/:subArea?'} component={ProfessionalAudio} />
            <Route exact path={'/public-spaces/:subArea?'} component={PublicSpaces} />
            <Route exact path={'/workspaces/:subArea?'} component={Workspaces} />
            <Route exact path={'/hifi-and-home-cinema/:subArea?'} component={HifiHomeCinema} />

            <Route exact path={'/product/:id'} render={({match}) => <ProductContainer key={match.params.id} id={match.params.id} />} />
            <Route exact path={'/bundle/:id'} render={({match}) => <BundleContainer key={match.params.id} id={match.params.id} />} />
            <Route exact path={'/bundles'} component={BundlesContainer} />
            
            <Route exact path={'/portfolio/:area?/:subArea?'} component={PortfolioContainer} />
            <Route exact path={'/project/:id'} render={({match}) => <ProjectContainer key={match.params.id} id={match.params.id} />} />

            <Route exact path={'/news'} component={News} />
            <Route exact path={'/news/:id'} render={({match}) => <NewsArticleContainer key={match.params.id} id={match.params.id} />} />

            <Route exact path={'/p/:id'} render={({match}) => <PagesContainer key={match.params.id} id={match.params.id} />} />

            <Route exact path={'/all-about-acoustics'} component={Articles} />
            <Route exact path={'/article/:id'} render={({match}) => <Article key={match.params.id} id={match.params.id} />} />

            <Route exact path={'/search/:query'} component={SearchContainer} />
            <Route exact path={'/all-products'} component={AllProductsContainer} />
            <Route exact path={'/catalogs/:area?'} component={CatalogsContainer} />
            <Route exact path={'/white-papers/:area?'} component={WhitepapersContainer} />

						<Route exact path={'/order-builder'} component={BulkBuy} /> 
						<Route exact path={'/product-stock'} component={ProductStock} /> 
						<Route exact path={'/rt-tool'} component={RTToolCalculator} /> 

						<Route exact path={'/sustainability/:tab?'} component={Sustainability} /> 
						{/*<Route exact path={'/project-request'} component={ProjectRequest}/> */}
            <Route exact path={'/project-request'} component={CanaryProjectRequest} />
						<Route exact path={'/about/:tab?'} component={About} /> 
						<Route exact path={'/services/:tab?'} component={Services} /> 
            <Route exact path={'/business-area/:tab?'} component={BusinessAreas} /> 
            <Redirect exact path={'/business-areas/:tab?'} to={'/business-area/:tab?'} /> 

            <Route exact path={'/videos/:tab?'} component={Videos} /> 
            <Route exact path={'/quick-links/:tab?'} component={QuickLinks} /> 
						<Route exact path={'/acoustic-experience/:tab?'} component={AcousticPrinciples} /> 

						<Route exact path={'/login'} render={_props => {
							let redirectUrl = "/";
							if(_props.location.search) {
								const searchObj = parseSearch(_props.location.search);
								if(searchObj.hasOwnProperty("r")) {
									redirectUrl = searchObj["r"];
								}
							}
							return <Login mode="login" onAuthRedirectTo={redirectUrl} />
						}}/>
						<Route exact path={'/reset-password'} render={_props => {
							return <Login mode="reset" onAuthRedirectTo={"/"} />
						}}/>
						
						<Route exact path={'/reserved-area/:tab?'} component={ReservedArea} />
						<Route exact path={'/reserved-area/orders/:orderNumber'} component={OrderDetails} />
						<Route exact path={'/signup'} component={Signup} />
						<Route path={'/checkout'} component={Checkout} />
						<Route path={'/404'} component={NotFound} status={404} />
						<Route path={'/privacy-policy'} component={PrivacyPolicy} />
						<Route path={'/cookies-policy'} component={CookiesPolicy} />
						<Route path={'/where-to-buy'} component={WhereToBuy} />
						<Redirect from="*" to="/404" />
					</Switch>
				</Suspense>
				<Footer />
        <CookiesModal />
				<LiveChat license={8923309} />
				<Route path="/" render={({location}) => {
          ReactPixel.pageView(); // For tracking page view
					if (typeof window.ga === 'function') {
						window.ga('set', 'page', location.pathname + location.search);
						window.ga('send', 'pageview');
					}
					return null;
				}} />
			</ErrorBoundary>
		</React.Fragment>
	);
};

export default Client;
